function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Theme = /*#__PURE__*/function () {
  function Theme() {
    _classCallCheck(this, Theme);

    this.spacer = [];
    this.server = 'https://api.npoint.io/';
    this.data = {};
    this.breakpoint = {
      xxs: 320,
      xs: 414,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
      xxl: 1440,
      xxxl: 1600
    };
    this.elements = {
      contentPage: document.querySelector('.content-page'),
      header: document.querySelector('.header'),
      footer: document.querySelector('.footer'),
      navigation: document.querySelector('.header .navigation-menu')
    };
  }

  _createClass(Theme, [{
    key: "baseConfig",
    value: function baseConfig() {
      // Push Spacing
      var temp;

      for (var i = 1; i <= 10; i++) {
        temp = temp === undefined ? 2 : temp + temp;
        this.spacer.push(temp);
      }
    }
  }, {
    key: "navigation",
    value: function navigation() {
      var _this$elements = this.elements,
          header = _this$elements.header,
          navigation = _this$elements.navigation;
      navigation.querySelectorAll("ul:first-child a").forEach(function (link) {
        link.addEventListener("click", function (e) {
          var targetId = link.getAttribute("href");
          var offsetTop = parseInt(link.getAttribute("data-offset-top")) || 0; // Offset = 0 if it is not defined

          var targetElement = document.querySelector(targetId);

          if (targetElement) {
            e.preventDefault();
            var targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offsetTop; // window.scrollTo({ top: targetPosition, behavior: "smooth" });

            document.documentElement.velocity({
              scrollTop: targetPosition + 'px'
            }, {
              duration: 400
            });
          }
        });
      });
      window.addEventListener('scroll', function () {
        // Device is not Mobile, and HTML scrollY > <Header> height then toggle class "has-background"
        !detectMobile.isMobile && header.classList.toggle("has-background", window.scrollY > header.offsetHeight);
      });
    }
  }, {
    key: "appearanceOnTime",
    value: function appearanceOnTime() {
      var html = document.documentElement;
      var themeToggle = document.getElementById("mode-toggle");

      var applyTheme = function applyTheme() {
        // Add or remove dark mode class based on the time
        var isNight = new Date().getHours() >= 18 || new Date().getHours() < 6; // The second parameter can be used to determine whether the class is included or not. This example would include the 'dark-mode' class only if {isNight} is true

        html.classList.toggle("dark-mode", isNight);
        themeToggle.checked = !isNight;
      };

      themeToggle.addEventListener("change", function () {
        html.classList.toggle("dark-mode");
      });
      applyTheme();
    }
  }, {
    key: "animation",
    value: function animation() {
      var _this = this;

      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      // Human
      this.animation.human = function () {
        var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var value = 32,
            element = document.getElementById('boy');

        if (status) {
          element.velocity({
            transform: ["translate(0, 0)", "translate(10, ".concat(value, ")")]
          }, 2500).velocity({
            transform: ["translate(10, ".concat(value, ")"), "translate(0, 0)"]
          }, 4000, _this.animation.human);
        } else {
          element.velocity('stop');
        }
      }; // Trees


      this.animation.trees = function () {
        var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var valueY = 12,
            valueX = 24,
            element = document.getElementById('trees');
        if (status) element.velocity({
          transform: ["translate(0, 0)", "translate(".concat(valueX, ", ").concat(valueY, ")")]
        }, 3500).velocity({
          transform: ["translate(".concat(valueX, ", ").concat(valueY, ")"), "translate(0, 0)"]
        }, 5000, _this.animation.trees);else element.velocity('stop');
      }; // Container
      // this.animation.svg = (status = true)=> {
      //     let value = 1,
      // 		element = document.querySelector('.section-banner svg');
      // 	if(status)
      // 		element
      // 		.velocity({ transform: ["scale(0.97)", `scale(${value})`] }, 3500)
      // 		.velocity({ transform: [`scale(${value})`, "scale(0.97)"] }, 5000, this.animation.svg);
      // 	else
      // 		element.velocity('stop');
      // };
      // Light Shape


      this.animation.lightShape = function () {
        var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var value = 1.04,
            element = document.getElementById('light-shape');
        if (status) element.velocity({
          transform: ["scale(1)", "scale(".concat(value, ")")]
        }, 3500).velocity({
          transform: ["scale(".concat(value, ")"), "scale(1)"]
        }, 5000, _this.animation.lightShape);else element.velocity('stop');
      }; // Section Profile
      // Profile


      this.animation.profile = function () {
        var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var element = document.getElementById('DESIGNERDEVELOPER');
        if (status) element.velocity({
          opacity: 0.1
        }, {
          loop: true
        });else element.velocity('stop');
      }; // Section Contact
      // Hand Shake


      this.animation.handShake = function () {
        var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var hand = Snap.select('#Hand'),
            handBBbox = hand.getBBox();
        var state = true;

        var waveLeft = function waveLeft() {
          hand.animate({
            transform: "r8, ".concat(handBBbox.cx, ", ").concat(handBBbox.y2)
          }, 500);
        };

        var waveRight = function waveRight() {
          hand.animate({
            transform: "r-2, ".concat(handBBbox.cx, ", ").concat(handBBbox.y2)
          }, 500);
        };

        waveRight();
        setInterval(function () {
          if (state) {
            waveLeft();
            state = false;
          } else {
            waveRight();
            state = true;
          }
        }, 500);
      };

      this.animation.human(status);
      this.animation.trees(status); // this.animation.svg(status);

      this.animation.lightShape(status);
      this.animation.profile(status);
      this.animation.handShake(status);
    }
  }, {
    key: "testimonialSwiper",
    value: function testimonialSwiper() {
      new Swiper('.section-testimonials .swiper-container', {
        mousewheel: true,
        keyboard: true,
        parallax: true,
        grabCursor: true,
        loop: true,
        speed: 600,
        pagination: {
          el: ".swiper-pagination",
          clickable: true //- dynamicBullets: true,

        }
      });
    }
  }, {
    key: "workSwiper",
    value: function workSwiper() {
      var _this2 = this;

      if (window.innerWidth <= this.breakpoint.sm && !this.listView) {
        // < 576
        document.querySelectorAll('.section-work .item').forEach(function (el, i) {
          el.style.maxWidth = window.innerWidth - _this2.spacer[6] - _this2.spacer[5] + 'px';
        });
      }

      var filterButtons = document.querySelectorAll('.section-work .navigation-tabs ul a'),
          switchViewButtons = document.querySelectorAll('.section-work .navigation-tabs .switch-view a'),
          switchGirdButton = document.querySelector('.section-work .navigation-tabs .switch-view a[action="grid"]'),
          switchListButton = document.querySelector('.section-work .navigation-tabs .switch-view a[action="list"]'),
          filterLi = document.querySelectorAll('.section-work .navigation-tabs li'),
          buttonPrev = document.querySelectorAll('.section-work .slide-button-prev'),
          buttonNext = document.querySelectorAll('.section-work .slide-button-next'),
          container = document.querySelectorAll('.section-work .swiper-container'),
          row = document.querySelectorAll('.section-work .swiper-container .slide-wrapper'),
          item = document.querySelectorAll('.section-work .swiper-container .slide-wrapper .item'),
          title = document.querySelector('.section-work .section-title'),
          setttings = {
        slidesPerView: 'auto',
        slidesOffsetBefore: title.getBoundingClientRect().left,
        slidesOffsetAfter: title.getBoundingClientRect().left,
        // mousewheel: true,
        keyboard: true,
        parallax: true,
        pagination: {// el: ".swiper-pagination",
          // clickable: true,
          // type: "fraction",
        },
        navigation: {
          nextEl: ".slide-button-next",
          prevEl: ".slide-button-prev"
        },
        breakpoints: {
          576: {
            spaceBetween: 32
          },
          320: {
            spaceBetween: 16
          }
        }
      },
          gallerySlider = new Swiper('.section-work .swiper-container', setttings); // Click Grid view event

      switchGirdButton.addEventListener('click', function (e) {
        e.preventDefault();
        var $this = e.currentTarget;
        switchViewButtons.forEach(function (element, index) {
          return element.classList.remove('active');
        });
        $this.classList.add('active');
        container.forEach(function (element, index) {
          // Show Swiper navigation
          element.querySelector('.swiper-controls').style.display = 'block'; // Remove list view property classes

          element.classList.remove('container');
        });
        row.forEach(function (element, index) {
          return element.classList.remove('row');
        });
        item.forEach(function (element, index) {
          return element.classList.remove('col-md-6');
        });
        gallerySlider = new Swiper('.section-work .swiper-container', setttings);
      }); // Click List view event

      switchListButton.addEventListener('click', function (e) {
        e.preventDefault();
        var $this = e.currentTarget;
        switchViewButtons.forEach(function (element, index) {
          return element.classList.remove('active');
        });
        gallerySlider.forEach(function (element, index) {
          element.destroy();
        });
        $this.classList.add('active');
        filterLi.forEach(function (element, index) {
          if (element.classList[0] == 'active') {
            var target = element.children[0].getAttribute('data-tab-target').substring(1);
            container.forEach(function (element, index) {
              element.getAttribute('id') != target ? element.style.display = 'none' : 0; // Hide Swiper navigation

              element.querySelector('.swiper-controls').style.display = 'none'; // Add list view property classes

              element.classList.add('container');
              row.forEach(function (element, index) {
                return element.classList.add('row');
              });
              item.forEach(function (element, index) {
                return element.classList.add('col-md-6');
              });
            });
          }
        });
      }); // Click Filter tab navigation event

      filterButtons.forEach(function (element, index) {
        element.addEventListener('click', function (e) {
          e.preventDefault();
          var $this = e.currentTarget,
              $ul = $this.parentNode.parentNode,
              $li = $this.parentNode,
              dataTarget = $this.getAttribute('data-tab-target'),
              target = document.querySelector(dataTarget),
              containers = document.querySelectorAll('.section-work .swiper-container');
          filterLi.forEach(function (el, i) {
            return el.classList.remove('active');
          });
          $li.classList.add('active');
          containers.forEach(function (el, i) {
            if (getComputedStyle(el, null).display !== 'none') {
              el.velocity({
                opacity: 0
              }, 200, function () {
                el.style.display = 'none';
              });
            }
          });
          target.velocity({
            opacity: 1
          }, 200, function () {
            target.style.display = 'block';
            $ul.querySelectorAll('li').forEach(function (el, i) {
              if (el.classList.contains('active')) {
                gallerySlider[i].update();
              }
            });
          });
        });
      }); // Cheat for open list view by default

      trigger(switchListButton, 'click');
    }
  }, {
    key: "photoswipeInit",
    value: function photoswipeInit(container, gallerys, thumbnails, database) {
      var $pswp = document.querySelector('.pswp'),
          $container = document.querySelector(container),
          $gallerys = $container.querySelectorAll(gallerys); // Get data featured

      var parseDataFeatured = function parseDataFeatured(database) {
        var database_featured = [];

        for (var type in database) {
          database[type].data.forEach(function (item, index) {
            var isFeatured = database[type].data[index].featured;
            typeof isFeatured === 'boolean' && isFeatured ? database_featured.push(item) : 0;
          });
        }

        return database_featured;
      }; // Get Data


      var parseData = function parseData(gid, database) {
        gid = gid.replace('category-', '');
        return gid === 'featured' ? parseDataFeatured(database) : database[gid].data;
      }; // Open Photoswipe from URL


      (function () {
        var hash = window.location.hash.substring(1);

        if (hash.includes('gid') && hash.includes('pid')) {
          var vars = hash.split('&').slice(1, 3),
              gid = vars[0].substring(4),
              pid = vars[1].substring(4),
              options = {
            arrowEl: true,
            bgOpacity: 0.8,
            index: parseInt(pid.split('-').pop()),
            galleryUID: gid
          };
          var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, parseData(gid, database), options);
          gallery.init();
        }
      })();

      var thumbnailsOnClick = function thumbnailsOnClick(e) {
        e.preventDefault();
        var thumbnail = e.currentTarget,
            gid = thumbnail.closest(gallerys).getAttribute('id'),
            options = {
          arrowEl: true,
          bgOpacity: 0.8,
          index: parseInt(thumbnail.getAttribute('data-img-index')),
          galleryUID: gid,
          getThumbBoundsFn: function getThumbBoundsFn(index) {
            // get window scroll Y
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop; // optionally get horizontal scroll
            // get position of element relative to viewport

            var rect = thumbnail.getBoundingClientRect(); // w = width

            return {
              x: rect.left,
              y: rect.top + pageYScroll,
              w: rect.width
            };
          }
        };
        var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, parseData(gid, database), options);
        lightBox.init();
      }; // Thumbnails on click


      $gallerys.forEach(function (el, i) {
        el.querySelectorAll(thumbnails).forEach(function (element, index) {
          element.onclick = function (e) {
            thumbnailsOnClick(e);
          };
        });
      });
    }
  }, {
    key: "loading",
    value: function loading() {
      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
      var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Loading...';
      var src = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'assets/images/logo.svg';
      var loader,
          loaderHTML = "\n\t\t\t<div class=\"page-loader\">\n\t\t\t\t<div class=\"loader-content\"><img class=\"logo-img\" src=\"".concat(src, "\"/>\n\t\t\t\t\t<div class=\"page-loader-title mt-2\">").concat(description, "</div>\n\t\t\t\t</div>\n\t\t\t</div>"); // Append loading

      document.body.style.overflow = 'hidden';
      document.body.style.display = '';
      document.body.style.backgroundColor = '';
      document.body.insertAdjacentHTML('beforeend', loaderHTML);
      loader = document.body.querySelector('.page-loader');
      setTimeout(function () {
        // Time to show loading - 1s
        document.body.style.overflow = '';
        loader.classList.add('move2Left', 'animated'); // loader.addEventListener("animationend", () => loader.remove());
      }, timeout);
    }
  }, {
    key: "mobileResponsive",
    value: function mobileResponsive() {
      var container = document.querySelector('.section-banner'),
          row = container.querySelector('.row'),
          background = container.querySelector('.content-bg'),
          text = container.querySelector('.content-text'),
          svg = container.querySelector('svg');

      if (detectMobile.isMobile) {
        document.body.classList.add('is-mobile'); // Fix bug for use Navigation bottom

        document.body.style.paddingBottom = this.elements.header.offsetHeight + 'px'; // Turn off animation

        this.animation(false);
      } else {
        // Turn on animation
        this.animation();
      } // (Desktop: >= 992px)


      if (window.innerWidth >= this.breakpoint.lg) {
        row.style.height = _getHeight(svg) + 'px';
      } // (Tablet: >= 768px and < 992px)


      if (window.innerWidth >= this.breakpoint.md && window.innerWidth < this.breakpoint.lg) {
        var width = parseInt(_getWidth(svg) + this.spacer[4]),
            mt = 320;
        svg.setAttribute('width', "".concat(width, "px"));
        svg.setAttribute('viewBox', "0 0 ".concat(width, " 1093"));
        svg.style.transform = "translate(-164px, -".concat(mt, "px)");
        text.style.marginTop = "".concat(this.spacer[5], "px");
        background.style.height = "".concat(_getHeight(svg) - mt, "px");
      } // (Mobile Large: >= 576 and < 768px)


      if (window.innerWidth >= this.breakpoint.sm && window.innerWidth < this.breakpoint.md) {
        var _width = parseInt(window.innerWidth + this.spacer[5] + 480),
            height = 800;

        svg.setAttribute('width', "".concat(_width, "px"));
        svg.setAttribute('height', "".concat(height, "px"));
        svg.setAttribute('viewBox', "0 0 ".concat(_width, " ").concat(height));
        svg.style.transform = "translateX(-184px)";
        text.style.marginTop = "".concat(this.spacer[5], "px");
        svg.style.marginTop = "-".concat(this.spacer[7] + this.spacer[5], "px");
      } // (Mobile Small: < 576)


      if (window.innerWidth >= this.breakpoint.xxs && window.innerWidth < this.breakpoint.sm) {
        var _width2 = parseInt(window.innerWidth + this.spacer[5] + 480),
            _height = 800;

        svg.setAttribute('width', "".concat(_width2, "px"));
        svg.setAttribute('height', "".concat(_height, "px"));
        svg.setAttribute('viewBox', "0 0 ".concat(1200, " ", _height));
        svg.style.transform = "translateX(-184px)";
        text.style.marginTop = "".concat(this.spacer[5], "px");
        svg.style.marginTop = "-".concat(this.spacer[7] + this.spacer[5], "px");
      } // }

    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this3 = this;

      // Making a GET request
      // Get Banner data
      fetch(this.server + 'df2e5675f00bc58b57ca').then(function (response) {
        return response.json();
      }).then(function (data) {
        // Handle the API response data here
        _this3.data = data; // Sort the date by the index (Only apply for Arrray)

        _this3.data.profile = data.profile.sort(function (a, b) {
          return a.index - b.index;
        }); // Section Banner

        document.getElementById('section-banner-description').textContent = _this3.data.introduce.description;
        var hello = new Typewriter('#section-banner-title', {
          loop: true,
          delay: 75
        });
        hello.pauseFor(1800) // .typeString(this.data.introduce.title.text_1)
        // .pauseFor(300)
        // .deleteChars(this.data.introduce.title.text_1.length)
        .typeString(_this3.data.introduce.title.text_2).pauseFor(100).deleteChars(_this3.data.introduce.title.text_2.length).typeString(_this3.data.introduce.title.text_3).pauseFor(1000).start(); // Section Profile

        _this3.data.profile.forEach(function (item, i) {
          var element = '';

          if (item.activated) {
            if (item.type == 'dob') {
              element = "\n\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t<div class=\"title\">".concat(item.label, "</div>\n\t\t\t\t\t\t\t\t<span>").concat(item.value, " &nbsp;</span>\n\t\t\t\t\t\t\t\t<i style=\"color: var(--fg-main);\">\n\t\t\t\t\t\t\t\t\t(age ").concat(new Date().getFullYear() - item.birthYear, ")\n\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t");
            } else if (item.type == 'email') {
              element = "\n\t\t\t\t\t\t\t<li data-type=\"email\">\n\t\t\t\t\t\t\t\t<div class=\"title\">".concat(item.label, "</div>\n\t\t\t\t\t\t\t\t<div class=\"content\">\n\t\t\t\t\t\t\t\t\t<a class= href=\"mailto:").concat(item.value, "\">").concat(item.value, "</a>\n\t\t\t\t\t\t\t\t\t<i class=\"").concat(item.iconClassName != undefined ? item.iconClassName : '', "\" style=\"color: ").concat(item.textColor != undefined ? item.textColor : ' ', ";\"></i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t");
            } else if (item.type == 'phone') {
              element = "\n\t\t\t\t\t\t\t<li data-type=\"phone\">\n\t\t\t\t\t\t\t\t<div class=\"title\">".concat(item.label, "</div>\n\t\t\t\t\t\t\t\t<div class=\"content\">\n\t\t\t\t\t\t\t\t\t<a class= href=\"mailto:").concat(item.value, "\">").concat(item.value, "</a>\n\t\t\t\t\t\t\t\t\t<i class=\"").concat(item.iconClassName != undefined ? item.iconClassName : '', "\" style=\"color: ").concat(item.textColor != undefined ? item.textColor : ' ', ";\"></i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t");
            } else if (item.type == 'social') {
              element = "\n\t\t\t\t\t\t\t<li data-type=\"social\">\n\t\t\t\t\t\t\t\t<div class=\"title\">".concat(item.label, "</div>\n\t\t\t\t\t\t\t\t<div class=\"content\">\n\t\t\t\t\t\t\t\t\t<a href=\"").concat(item.href, "\">").concat(item.value, "</a>\n\t\t\t\t\t\t\t\t\t<i class=\"").concat(item.iconClassName != undefined ? item.iconClassName : '', "\" style=\"color: ").concat(item.textColor != undefined ? item.textColor : ' ', ";\"></i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t");
            } else if (item.type == 'exp') {
              element = "\n\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t<div class=\"title\">".concat(item.label, "</div>\n\t\t\t\t\t\t\t\t<span>\n\t\t\t\t\t\t\t\t\t").concat(new Date().getFullYear() - 1 - item.value, "\n\t\t\t\t\t\t\t\t\t&nbsp;yrs+ &nbsp;<i style=\"color: var(--fg-subtlest);\">(").concat(item.value, " - Present)</i>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t");
            } else if (item.type == 'personality') {
              element = "\n\t\t\t\t\t\t\t<li class=\"align-items-center\"><div class=\"personality-progress\"><div class=\"label\"><span><b>Introvert </b>(".concat(item.value, ")</span><span><b>Extrovert</b></span></div><div class=\"holder\"><div class=\"tracker\"></div><span class=\"emoji\">").concat(item.emoji, "</span></div></div></li>\n\t\t\t\t\t\t");
            } else {
              element = "\n\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t<div class=\"title\">".concat(item.label, "</div>\n\t\t\t\t\t\t\t\t<span>").concat(item.value, "</span>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t");
            }

            document.getElementById('section-profile-content').insertAdjacentHTML('beforeend', element);
          }
        }); // Section Testimonials


        _this3.data.testimonial.forEach(function (item, i) {
          return document.getElementById('section-testimonials-content').insertAdjacentHTML('beforeend', "\n\t\t\t\t\t<div class=swiper-slide>\n\t\t\t\t\t\t<i class=\"icon-quotes ri-double-quotes-l\" style=\"color: var(--fg-decor);\"></i>\n\t\t\t\t\t\t<div class=testimonials-description>".concat(item.message, "</div>\n\t\t\t\t\t\t<div class=testimonials-author-content>\n\t\t\t\t\t\t\t<div class=testimonials-author-content-left>\n\t\t\t\t\t\t\t\t<img class=testimonials-author-avatar src=").concat(item.avatar, " alt=").concat(item.author, ">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=testimonials-author-content-right>\n\t\t\t\t\t\t\t\t<div class=testimonials-author-name>\n\t\t\t\t\t\t\t\t\t").concat(item.author, "\n\t\t\t\t\t\t\t\t\t<a href=\"").concat(item.linkedin, "\">\n\t\t\t\t\t\t\t\t\t\t<i class=ri-linkedin-box-fill></i>\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=testimonials-author-role>").concat(item.role, "</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>"));
        }); // Section Footer


        var footer = new Typewriter('#section-footer-description', {
          loop: true,
          delay: 75,
          cursor: '',
          deleteSpeed: 'fast'
        });
        footer // .pauseFor(1800)
        .typeString(_this3.data.footer.text_1) // .pauseFor(100)
        .deleteChars(_this3.data.footer.text_1.length - 3).typeString(_this3.data.footer.text_2).deleteChars(_this3.data.footer.text_2.length - 3).pauseFor(100).start();
      })["catch"](function (err) {
        return console.error(err);
      });
    }
  }, {
    key: "init",
    value: function init() {
      this.baseConfig();
      this.navigation();
      this.loading();
      this.fetchData();
      this.mobileResponsive();
    }
  }]);

  return Theme;
}();